import { Controller } from "@hotwired/stimulus";

// Example HTML usage:
// <div data-controller="select-all">
//   <input
//     type="checkbox"
//     data-select-all-target="all"
//     data-action="change->select-all#toggleAll"
//   >
//
//   <input
//     type="checkbox"
//     data-select-all-target="item"
//     data-action="change->select-all#toggleItem"
//   >
//   <input
//     type="checkbox"
//     data-select-all-target="item"
//     data-action="change->select-all#toggleItem"
//   >
// </div>

export default class extends Controller {
  static targets = ["all", "item"];

  connect() {
    this.refreshAllState();
  }

  toggleAll() {
    const isChecked = this.allTarget.checked;

    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });

    this.refreshAllState();
  }

  toggleItem() {
    this.refreshAllState();
  }

  refreshAllState() {
    if (!this.hasAllTarget || this.itemTargets.length === 0) return;

    const checkedCount = this.itemTargets.filter(
      (checkbox) => checkbox.checked,
    ).length;
    const allChecked = checkedCount === this.itemTargets.length;
    const someChecked = checkedCount > 0 && !allChecked;

    this.allTarget.checked = allChecked;
    this.allTarget.indeterminate = someChecked;
  }
}
